import { createVM, show as _show, hide as _hide } from './util';

var $vm = void 0;

var plugin = {
  install: function install(Vue) {
    if (!$vm) {
      $vm = createVM(Vue);
    }

    var alert = {
      show: function show() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return _show.call(this, $vm, options);
      },
      hide: function hide() {
        return _hide.call(this, $vm);
      },
      isVisible: function isVisible() {
        return $vm.showValue;
      }
    };

    if (!Vue.$vux) {
      Vue.$vux = {
        alert: alert
      };
    } else {
      Vue.$vux.alert = alert;
    }

    Vue.mixin({
      created: function created() {
        this.$vux = Vue.$vux;
      }
    });
  }
};

export default plugin;
export var install = plugin.install;


// WEBPACK FOOTER //
// ./node_modules/vux/src/plugins/alert/index.js